module.exports = __webpack_public_path__ + "officialStatic/img/compalLogo.5629312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/compalLogo.png
// module id = kbZ0
// module chunks = 0